import { restaurantSchema } from "../configs";
import RestaurantForm from "../forms/Restaurant.form";
import { useCreateRestaurantMutation } from "../store";
import { showToast, ToastType } from "../utils/toast.utils";
import NavigationLinkBtn from "../components/common/NavigationLinkBtn";
import { FaArrowLeft } from "react-icons/fa";

const CreateRestaurant = () => {
  const [createRestaurant, { isLoading }] = useCreateRestaurantMutation();

  const initialValues = {
    displayName: "",
    description: "",
    email: "",
    password: "",
    city: undefined,
    orderTypes: [],
    address: {
      street: "",
      zipCode: "",
      city: "",
      coordinates: [undefined, undefined],
      country: "",
    },
    payout: { type: "ht", value: undefined },
    referant: { firstName: "", lastName: "", phone: "", siret: "" },
    settings: { allergensLink: "" },
    openingHours: [],
  };

  return (
    <div className="w-full mx-auto px-6 py-8">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-4">
          <NavigationLinkBtn
            to="/restaurants"
            label={<FaArrowLeft />}
            className="bg-white text-gray-800 border border-gray-200 hover:bg-gray-50 p-3 m-0 rounded-full shadow-sm transition-all flex items-center justify-center w-10 h-10"
          />
          <div>
            <h1 className="text-2xl font-bold text-gray-800">
              Nouveau Restaurant
            </h1>
            <p className="text-gray-500 text-sm mt-1">
              Remplissez le formulaire pour ajouter un partenaire
            </p>
          </div>
        </div>
      </div>

      <RestaurantForm
        initialValues={initialValues}
        validationSchema={restaurantSchema}
        isLoading={isLoading}
        onSubmit={async (values, { resetForm }) => {
          const result = await createRestaurant(values);
          if (!result.error) {
            showToast("Restaurant créé", ToastType.SUCCESS);
            resetForm();
          }
        }}
      />
    </div>
  );
};

export default CreateRestaurant;
